import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=70715150&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
import style0 from "./Comments.vue?vue&type=style&index=0&id=70715150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70715150",
  null
  
)

export default component.exports